import * as IF from "infrontjs";
import template from './template.html';

class HeaderBar extends HTMLElement
{
    constructor()
    {
        super();
        this._isConnected = false;
    }

    connectedCallback()
    {
        if ( false === this._isConnected )
        {
            this.app = IF.App.get();
            this.render();
            this.init();

            this._isConnected = true;
        }
    }

    init()
    {
        document.querySelectorAll(".sidebartoggler").forEach((element) => {
            element.addEventListener("click", function () {
                document.querySelectorAll(".sidebartoggler").forEach((el) => {
                    el.checked = true;
                });
                document
                    .getElementById("main-wrapper")
                    .classList.toggle("show-sidebar");
                document.querySelectorAll(".sidebarmenu").forEach((el) => {
                    el.classList.toggle("close");
                });
                const dataTheme = document.body.getAttribute("data-sidebartype");
                if (dataTheme === "full") {
                    document.body.setAttribute("data-sidebartype", "mini-sidebar");
                } else {
                    document.body.setAttribute("data-sidebartype", "full");
                }
            });
        });
    }

    render()
    {
        this.app.view.render(
            this,
            template,
            {
                user: this.app.user
            }
        );
    }
}

customElements.define( 'header-bar', HeaderBar );
